import { inject, Injectable, signal } from '@angular/core';
import { ApiDataAccess } from '@softline/core';

export interface TerminalState {
  test: string;
}

@Injectable()
export class TerminalInitService {
  private dataAccess = inject(ApiDataAccess);

  readonly state = signal<string | null>(null);
  readonly initialized = signal(false);

  async init(): Promise<string> {
    const result = await this.dataAccess.create<object, string>(
      {
        path: 'pointofsale-service/point-of-sale/init-terminal',
      },
      {}
    );

    this.state.set(result);
    this.initialized.set(true);
    return result;
  }

  async close(): Promise<void> {
    await this.dataAccess.create(
      {
        path: 'pointofsale-service/point-of-sale/close-terminal',
      },
      {}
    );

    this.initialized.set(false);
    // this.state.set(null);
  }
}
